import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EnvService } from './env.service';

export class TareaCasoModel {
  _id?: string;
  idTarea?: string;
  idCaso?: string;
  estado?: string;
  deleted?: boolean;
  lastUser?: string;
  files?: any[];
  observaciones_text?: string;
  orden_prioridad?: number;
  createdAt?: Date;
  updatedAt?: Date;

  personalInternoInvolucrado?: string;
  estafa?: string;
  ingresosDescono?: string;
  data?: any;
}

export class TareaCasoMixedModel {
  _id?: string;
  estado_caso?: string;
  tareacasoId?: string;
  checked?: string;
  tipo_caso?: string;
  titulo?: string;
  descripcion?: string;
  observaciones?: string;
  requerido?: string;
  archivos_adjuntos?: string;
  tabla?: string;
  creadoPor?: string;
  asignadoA?: string;
  createdAt?: Date;
  updatedAt?: Date;
  deleted?: boolean;
  orden_prioridad?: number;
  personType?: 'n' | 'j';
  idTarea?: any;
  idCaso?: any;
  estado?: string;
  lastUser?: string;
  observaciones_text?: string;
  files?: any[];
  personalInternoInvolucrado?: string;
  estafa?: string;
  ingresosDescono?: string;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class TareaCasoService {
  constructor(public http: HttpClient, private env: EnvService) { }

  // headers = new HttpHeaders().set('Content-Type', 'application/json');

  post(tareaCaso: TareaCasoModel): Observable<any> {
    return this.http.post(`${this.env.URL_API}/tareacaso`, tareaCaso);
  }

  put(id: string, tareaCaso: TareaCasoMixedModel): Observable<any> {
    return this.http.put(`${this.env.URL_API}/tareacaso/${id}`, tareaCaso);
  }
  updateColumn(id: string, columna: string): Observable<any> {
    return this.http.put(`${this.env.URL_API}/tarea/updatecolumn/${id}`, {
      estado: columna,
    });
  }

  putOrden(id: string, tareaCaso: TareaCasoMixedModel): Observable<any> {
    return this.http.put(
      `${this.env.URL_API}/tareacasoordenprioridad/${id}`,
      tareaCaso
    );
  }

  get(): Observable<any> {
    return this.http.get(`${this.env.URL_API}/tareacaso`);
  }

  getById(id: string): Observable<any> {
    return this.http.get(`${this.env.URL_API}/tareacaso/${id}`);
  }

  getByCaso(idCaso: string): Observable<any> {
    return this.http.get(`${this.env.URL_API}/tareacasoByCaso/${idCaso}`);
  }

  getByIdCasoIdTarea(idCaso: string, idTarea: string): Observable<any> {
    return this.http.get(
      `${this.env.URL_API}/tareacasoByIdCasoIdTarea/${idCaso}/${idTarea}`
    );
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.env.URL_API}/tareacaso/${id}`);
  }

  subir_archivo_adjunto(file) {
    return this.http.post(
      `${this.env.URL_API}/tareacaso/subir_archivo_adjunto`,
      file
    );
  }

  get10modified(body = null): Observable<any> {
    return this.http.post(
      `${this.env.URL_API}/tareacaso/ultimosdieztareaseditados`,
      body
    );
  }

  crearTarea(id_caso: string, titulo_tarea: string) {
    return this.http.post(`${this.env.URL_API}/tareacaso/crearTarea`, {
      id_caso,
      titulo_tarea,
    });
  }

  requestApproval(
    idCaso,
    data: { user: string; comment: string }
  ): Observable<any> {
    return this.http.post(
      `${this.env.URL_API}/caso_tarea/requestApproval/${idCaso}`,
      data
    );
  }
  rejectApproval(
    idCaso,
    data: { user: string; comment: string }
  ): Observable<any> {
    return this.http.post(
      `${this.env.URL_API}/caso_tarea/rejectApproval/${idCaso}`,
      data
    );
  }
  acceptApproval(idCaso, data: { user: string }): Observable<any> {
    return this.http.post(
      `${this.env.URL_API}/caso_tarea/acceptApproval/${idCaso}`,
      data
    );
  }
}
